import { useLang } from "@/i18n";

export const Stats = () => {
  const { t } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-12 pb-20 sm:pb-28" data-testid="stats-section">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#D3CEC4]/60 border border-[#D3CEC4]/60 rounded-2xl overflow-hidden">
        {t.home.stats.map((s, i) => (
          <div key={s.k} className="bg-[#F8F6F0] p-6 sm:p-8" data-testid={`stat-${i}`}>
            <p className="font-serif text-3xl sm:text-4xl text-[#1A2522] uppercase tracking-tight">{s.k}</p>
            <p className="text-xs sm:text-[13px] text-[#495854] mt-2 leading-snug">{s.v}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
